import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes - data is fresh for 2 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes - cache persists for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      retry: 1, // Retry failed requests once
      refetchOnMount: 'stale', // Only refetch on mount if data is stale
      networkMode: 'online', // Better handling of offline state
    },
    mutations: {
      retry: 0, // Don't retry mutations by default
      networkMode: 'online',
    },
  },
});
